/* ============================================================
   SSREC ERP — integrated with Noris PHP API
   API files: Login.php, GetApi.php, PostApi.php, DeleteApi.php
   ------------------------------------------------------------
   SET THIS to where the PHP files are hosted. Leave '' if this
   HTML is served from the SAME folder as the .php files.
   e.g. 'https://ssrec.noris.in/ERP/'
   ============================================================ */
export const API_BASE = 'https://norisapi.noris.in/ERP/';
export const THU_IMIE = 'IMIE20092025';      // Thumkunta — ShowLoadConveyorData / detail use this ID
                                      // Shamshabad uses the logged-in IMIE (e.g. IMIE19092025)
export const appState = { OFFLINE:false };                   // set true automatically if the server can't be reached
export const session = {IMIE:'', user:'', company:'', typed:'', role:'unofficial'};

/* TableName mapping — change here if your account uses different tables */
export const EP = {
  autoList:    'conveyorReading',            // Automatic Operations — list of date totals (GET)
  autoDetail:  'conveyorReadingByDate',      // Automatic off-canvas — readings for one date (POST {Date1})
  manualList:  'conveyorReadingEntered',     // Manual Operations — list of date totals (GET)
  manualDetail:'conveyorReadingEnteredByDate',       // Manual off-canvas — readings for one date (POST {Date1})
  plant:       'ShowLoadConveyorData',       // Plant processing by range (POST {FromDate,ToDate})
  chartByDate: 'conveyorReadingByDate'       // Dashboard chart — one date's readings (POST {Date1})
};
